<!-- Portal-Hinweis unten links neben der Seitenleiste. Dunkel wie die
     Tooltips des Portals (gleiche `--tooltip-*`-Werte, Marcel 19.10.2026). -->
<aside
  *ngIf="hint && animation"
  class="portal-hint"
  [style.left.px]="left"
  role="complementary"
  [attr.aria-label]="hint.def.titleKey | translate"
>
  <div class="portal-hint__body">
    <header class="portal-hint__head">
      <h6 class="portal-hint__title">{{ hint.def.titleKey | translate }}</h6>
      <button
        type="button"
        class="al-icon-button portal-hint__close"
        [attr.aria-label]="'portalHints.close' | translate"
        [nbTooltip]="'portalHints.close' | translate"
        (click)="dismiss()"
      >
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </header>

    <!-- Orbi schaut rechts hinter dem Film hervor: liegt unter dem Film
         (z-index), gleitet einmal heraus und neigt sich (SCSS), dann spielt
         der Lab-Ablauf `orbiScript` — blinzeln, kichern, freuen. -->
    <div class="portal-hint__media">
      <div class="portal-hint__orbi" aria-hidden="true">
        <app-orbi-lab type="tutor" [size]="56" [script]="orbiScript"></app-orbi-lab>
      </div>
      <!-- „Erledigt ✓“: kurz über dem Film, wenn der Schritt geschafft ist —
           danach folgt der nächste offene Hinweis (DONE_FLASH_MS). -->
      <div class="portal-hint__done" *ngIf="doneFlash" role="status">
        <span class="portal-hint__done-check" aria-hidden="true">
          <nb-icon icon="checkmark-outline"></nb-icon>
        </span>
        {{ 'portalHints.done' | translate }}
      </div>
      <app-hint-film
        class="portal-hint__film"
        [animation]="animation"
        [width]="384"
        [attr.aria-label]="(hint.def.titleKey + 'Alt') | translate"
      ></app-hint-film>
    </div>

    <!-- Ziel unten: kleiner Knopf „Gehe zu" + wohin man kommt; die ganze
         Zeile ist der Link (Marcel, 19.10.2026: als Link erkennbarer). -->
    <div class="portal-hint__links" [class.is-hidden]="doneFlash">
      <a
        *ngIf="hint.link && (hint.linkKey || hint.def.linkKey) && !onTargetPage"
        class="portal-hint__link"
        [routerLink]="hint.link"
        (click)="go()"
      >
        <span class="portal-hint__go">
          {{ 'portalHints.goTo' | translate }}
          <nb-icon icon="arrow-forward-outline"></nb-icon>
        </span>
        <span class="portal-hint__target">{{ (hint.linkKey || hint.def.linkKey)! | translate: { name: hint.agentName } }}</span>
      </a>
      <!-- Hinweis A: Aktion an Ort und Stelle statt Link (Orbi öffnen). -->
      <button
        *ngIf="hint.def.action && hint.def.actionKey"
        type="button"
        class="portal-hint__link portal-hint__link--action"
        (click)="runAction()"
      >
        <span class="portal-hint__go">
          {{ 'portalHints.open' | translate }}
          <nb-icon icon="arrow-forward-outline"></nb-icon>
        </span>
        <span class="portal-hint__target">{{ hint.def.actionKey | translate }}</span>
      </button>
      <a
        *ngFor="let l of hint.def.externalLinks"
        class="portal-hint__link"
        [href]="l.url"
        target="_blank"
        rel="noopener"
      >
        <span class="portal-hint__go">
          {{ 'portalHints.goTo' | translate }}
          <nb-icon icon="external-link-outline"></nb-icon>
        </span>
        <span class="portal-hint__target">{{ l.labelKey | translate }}</span>
      </a>
    </div>

    <!-- Academy: dieselbe Inhaltsbasis (academy-catalog.ts) — die Lektion
         zum Hinweis und die Übersicht aller Portalhinweise. -->
    <div class="portal-hint__academy" [class.is-hidden]="doneFlash">
      <a *ngIf="academyLesson as lessonId" [routerLink]="['/academy/lessons', lessonId]">
        {{ 'portalHints.learnMore' | translate }}
      </a>
      <a routerLink="/academy" [queryParams]="{ view: 'hints' }">
        {{ 'portalHints.allHints' | translate }}
      </a>
    </div>
  </div>
</aside>
